// Entry point.
//
// It renders immediately. Firebase is started by <AuthProvider>, not awaited
// here, because "/" is a marketing page now: gating the first paint on a config
// fetch meant a first-time visitor looked at a white screen until it came back,
// and at an apologetic error card if it did not. The pages that genuinely need
// auth wait for it themselves (see App.tsx), which is the only place the wait
// costs nobody anything.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { loadAdsTag } from "./lib/ads";
import { reloadOnStaleBuild } from "./lib/staleBuild";
import { startAnalytics } from "./lib/analytics";
import "./index.css";

// Google Ads measurement, on buildbotsnow.com only (lib/ads.ts).
loadAdsTag();
// Google Analytics on the same tag, once its property id is set (lib/analytics.ts).
startAnalytics();

// A tab older than the last deploy reloads instead of going blank (lib/staleBuild.ts).
reloadOnStaleBuild();

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
